<template>
  <div class="vacancy_modal modal" v-if="$store.state.main.lead_modal">
    <div class="phone_modal__overlay bg-overlay" @click="close_modal"></div>
    <div
      class="vacancy_modal__inner bg-white"
      :class="{ mob_100: windowWidth <= 767 }"
    >
      <div class="vacancy_modal__ttl_wrapper flex j_sb a_center">
        <span class="f-24 bold uppercase f-light-purple" v-if="!success_sent">{{
          $fn.tr("შეავსე აპლიკაცია")
        }}</span>
        <span class="f-24 bold uppercase f-light-purple" v-else>{{
          $fn.tr("აპლიკაცია წარმატებით გაიგზავნა")
        }}</span>

        <div class="vacancy_modal__x_btn pointer" @click="close_modal()">
          <svg
            id="Group_4238"
            data-name="Group 4238"
            xmlns="http://www.w3.org/2000/svg"
            width="16.971"
            height="16.971"
            viewBox="0 0 16.971 16.971"
          >
            <rect
              id="Rectangle_543"
              data-name="Rectangle 543"
              width="20"
              height="4"
              rx="2"
              transform="translate(2.828 0) rotate(45)"
            />
            <rect
              id="Rectangle_1219"
              data-name="Rectangle 1219"
              width="20"
              height="4"
              rx="2"
              transform="translate(16.971 2.829) rotate(135)"
            />
          </svg>
        </div>
      </div>

      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="vacancy_modal__form"
        v-show="!success_sent"
      >
        <el-form-item prop="type">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--name not-selectable"
            >{{ $store.state.main.lead_modal_type.type }}</span
          >
          <el-input :disabled="true"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--name"
            :class="{ selected: ruleForm.name.length !== 0 }"
            >{{ $fn.tr("სახელი") + "*" }}</span
          >
          <el-input
            v-model="ruleForm.name"
            @focus="add_focus('name')"
            @blur="remove_focus('name', ruleForm.name)"
          ></el-input>
        </el-form-item>

        <el-form-item prop="phone">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--phone"
            :class="{ selected: ruleForm.phone.length !== 0 }"
            >{{ $fn.tr("მობილურის ნომერი") + "*" }}</span
          >

          <el-input
            v-model.number="ruleForm.phone"
            type="number"
            @focus="add_focus('phone')"
            @blur="remove_focus('phone', ruleForm.phone)"
          ></el-input>
        </el-form-item>

        <el-form-item prop="desc">
          <span
            class="f-16 medium el-input__placeholder el-input__placeholder--textarea"
            :class="{ selected: ruleForm.desc.length !== 0 }"
            >{{ $fn.tr("კომენტარი") }}</span
          >

          <el-input
            type="textarea"
            v-model="ruleForm.desc"
            @focus="add_focus('textarea')"
            @blur="remove_focus('textarea', ruleForm.desc)"
          ></el-input>
        </el-form-item>

        <vue-recaptcha
          ref="recaptcha"
          :sitekey="$store.state.main.indx.siteSettings.google_recaptcha_key"
          :loadRecaptchaScript="true"
          class="g-recaptcha"
          @verify="recaptcha_success()"
          @error="recaptcha_fail()"
        ></vue-recaptcha>

        <div class="vacancy_modal__terms flex">
          <span class="f-16 regular"
            >{{
              _.get(
                this.$store.state.main.current_content,
                "primary.conf.header.teaser"
              )
            }}
            <a
              :href="
                _.get(
                  this.$store.state.main.current_content,
                  'primary.conf.header.full_list_url'
                )
              "
              class="f-16 regular"
            >
              {{
                _.get(
                  this.$store.state.main.current_content,
                  "primary.conf.header.full_list_title"
                )
              }}
            </a>
          </span>
        </div>

        <el-form-item>
          <el-button
            class="button vacancy_modal_validate_button"
            @click="submitForm('ruleForm')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                fill="#fff"
              />
            </svg>
            <span class="f-16 bold uppercase f-white">{{
              $fn.tr("გაგზავნა")
            }}</span>
          </el-button>
        </el-form-item>
      </el-form>

      <div
        class="vacancy_modal__success flex column a_center"
        v-show="success_sent"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="178.371"
          height="194.421"
          viewBox="0 0 178.371 194.421"
        >
          <g
            id="Group_5300"
            data-name="Group 5300"
            transform="translate(-160.864 0.758)"
          >
            <path
              id="Path_2764"
              data-name="Path 2764"
              d="M277.445,63.641c-2.971-1.925,6.464-4.386,6.464-4.386s6.921-1.89,4.336-5.375c-2.547-3.434-5.613,2.392-16.1,5.574s-16.692-10.127-21.4-9.865-3.679,10.668-6.5,11.337-4.814-6.742-4.814-6.742-3.94-14.195,13.4-20.339,20.472,1.888,29.484-9.455,16.762-5.968,21.487,1.9c10.641,17.72-8.856,38.32-26.209,37.4Z"
              transform="translate(-14.742 -17.887)"
              fill="#7063e9"
              stroke="#707070"
              stroke-width="1.5"
            />
            <path
              id="Path_2765"
              data-name="Path 2765"
              d="M256.751,263.141"
              transform="translate(-20.27 -94.489)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2766"
              data-name="Path 2766"
              d="M251.219,236.408l3.717-.347a21.2,21.2,0,0,0,2.773-.429,11.926,11.926,0,0,0,1.693-.51c15.669-6.12,24.765-20.236,24.765-37.168a37.774,37.774,0,0,0-.214-4.022l14.234-1.443-.368-4.6-8.6,1.12"
              transform="translate(-18.542 -70.985)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2767"
              data-name="Path 2767"
              d="M236.643,57.809s-3.94-14.195,13.4-20.339,20.472,1.888,29.485-9.455,16.762-5.968,21.487,1.9c10.641,17.719-8.856,38.32-26.209,37.4"
              transform="translate(-13.87 -19.02)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2768"
              data-name="Path 2768"
              d="M298.67,55.318c-.016-4.416-2.019-8.039-6.789-9.3-9.259-2.445-12.139,6.254-22.44,8.706S258.1,47,246.7,51.047s-9.914,14.282-9.914,14.282,1.994,7.41,4.814,6.742S243.4,61,248.1,60.734s10.914,13.048,21.4,9.865,13.55-9.007,16.1-5.574c2.585,3.486-4.336,5.375-4.336,5.375"
              transform="translate(-14.016 -26.54)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <line
              id="Line_315"
              data-name="Line 315"
              x1="1.594"
              y2="3.966"
              transform="translate(240.566 44.059)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <line
              id="Line_316"
              data-name="Line 316"
              x1="1.594"
              y2="3.966"
              transform="translate(255.597 48.844)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2769"
              data-name="Path 2769"
              d="M275.971,86.247l-3.515,5.968s3.456-.792,3.948.9c.546,1.879-.326,2.918-4.827,3.8"
              transform="translate(-24.901 -39.239)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2770"
              data-name="Path 2770"
              d="M261.758,94.391s-.879,4.413,2.769,5.067"
              transform="translate(-21.805 -41.782)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2771"
              data-name="Path 2771"
              d="M234.708,75.769s-5.27-1.128-5.662,3.654c-.373,4.532,4.349,6.3,8.3,5.931,0,0-2.479,14.138,13.45,17s20.176-8.849,20.957-14.081a22.956,22.956,0,0,0,0-8.284"
              transform="translate(-11.61 -35.93)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2772"
              data-name="Path 2772"
              d="M289.677,97.029s5.247.457,6.881-2.74,0-7.154,0-7.154"
              transform="translate(-30.554 -39.516)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2773"
              data-name="Path 2773"
              d="M235.65,80.449a1.91,1.91,0,0,0-1.344,2.012c.249,1.487,2.223,1.7,2.223,1.7"
              transform="translate(-13.251 -37.428)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2774"
              data-name="Path 2774"
              d="M293.141,95.678a1.911,1.911,0,0,0,2.12-1.168c.464-1.434-1.192-2.529-1.192-2.529"
              transform="translate(-31.636 -41.03)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2775"
              data-name="Path 2775"
              d="M242.775,104.8s.162,8.7-3.371,15.719"
              transform="translate(-14.852 -45.035)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2776"
              data-name="Path 2776"
              d="M262.86,115.292a67.959,67.959,0,0,0-.286,11.337"
              transform="translate(-22.048 -48.31)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2777"
              data-name="Path 2777"
              d="M300.865,195.735q.026.824.025,1.656c0,20.775-9.916,39.71-29.046,46.577"
              transform="translate(-24.984 -73.436)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2778"
              data-name="Path 2778"
              d="M263.337,128.165"
              transform="translate(-22.327 -52.331)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2779"
              data-name="Path 2779"
              d="M199.926,187.934l-22.353-16.406,33.207-.139s4.992,4.884,6.412,16.045C217.191,187.434,202.332,184.794,199.926,187.934Z"
              transform="translate(4.46 -65.832)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2780"
              data-name="Path 2780"
              d="M232.619,184.814l30.2.348,12.993,7.635-.082.327-41.642-1.507"
              transform="translate(-12.733 -70.025)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2781"
              data-name="Path 2781"
              d="M275.505,181.339c.8-3.9,9.419-9.261,9.419-9.261,13.734,6.02,15.286,5.144,21.418,1.635,0,0-6.729,10.194-17.215,15.433"
              transform="translate(-26.128 -66.047)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2782"
              data-name="Path 2782"
              d="M188.453,194.208q-.065,1.344-.065,2.706c0,24.319,15.584,44.619,36.076,48.363a43.023,43.023,0,0,0,19.867-1.126,2.453,2.453,0,0,0-.942-4.814s-7.993,3.04-14.86,1.906"
              transform="translate(1.082 -72.959)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2783"
              data-name="Path 2783"
              d="M189.787,181.461q-.468,2.2-.758,4.47"
              transform="translate(0.882 -68.977)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2784"
              data-name="Path 2784"
              d="M192.928,158c5.412-15.187,17.351-26.631,31.811-29.871l-.01.224q-.032.333-.032.675c0,4.252,3.755,7.737,8.387,7.7,7.593-.063,8.223-8.379,8.223-8.379,15.038,3.679,27.667,16.214,32.653,32.547l.5,1.889"
              transform="translate(-0.336 -52.321)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2785"
              data-name="Path 2785"
              d="M229.161,239.3a1.753,1.753,0,1,0,.975-3.368L225.6,235.3a12.486,12.486,0,0,1-2.826-.712c-15.669-6.12-24.765-20.236-24.765-37.168a37.758,37.758,0,0,1,.214-4.022l-14.235-1.443.368-4.6,11.956,1.595"
              transform="translate(2.455 -70.818)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2786"
              data-name="Path 2786"
              d="M205.1,192.4q-.275,1.255-.462,2.559"
              transform="translate(-3.994 -72.394)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2787"
              data-name="Path 2787"
              d="M216.142,167.383s-.677.865-1.655,2.392"
              transform="translate(-7.069 -64.58)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <line
              id="Line_317"
              data-name="Line 317"
              x1="1.66"
              y2="18.438"
              transform="translate(202.726 122.102)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <line
              id="Line_318"
              data-name="Line 318"
              x1="1.85"
              y2="39.61"
              transform="translate(219.802 121.603)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <line
              id="Line_319"
              data-name="Line 319"
              x1="1.144"
              y2="21.418"
              transform="translate(261.903 123.199)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2788"
              data-name="Path 2788"
              d="M312.843,183.71c.224,1.285.415,2.682.549,4.182"
              transform="translate(-37.79 -69.68)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2794"
              data-name="Path 2794"
              d="M199.161,238s.736,14.837-.368,26c0,0,1.594-6.091,11.159-3.393s29.061,8.614,46.107,4.987c11.527-2.453,11.772-5.641,11.772-5.641l-1.962-14.47"
              transform="translate(-2.167 -86.636)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2795"
              data-name="Path 2795"
              d="M223.494,275.861s1.308,13.08-16.677,12.262"
              transform="translate(-4.674 -98.462)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2796"
              data-name="Path 2796"
              d="M282.042,278.12s-1.063,7.929,5.8,7.766"
              transform="translate(-28.151 -99.168)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <line
              id="Line_325"
              data-name="Line 325"
              x2="20.437"
              transform="translate(223.562 162.848)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2804"
              data-name="Path 2804"
              d="M198.795,275.573s-.9,4.3,6.057,5.215"
              transform="translate(-2.156 -98.372)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2805"
              data-name="Path 2805"
              d="M148.982,283.743l13.08-27.141,4.9,7.194-18.639,21.255"
              transform="translate(13.594 -92.447)"
              fill="none"
              stroke="#fec41d"
              stroke-linecap="square"
              stroke-miterlimit="10"
              stroke-width="1.5"
            />
            <line
              id="Line_327"
              data-name="Line 327"
              x2="5.845"
              y2="5.845"
              transform="translate(162.986 31.884)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <line
              id="Line_328"
              data-name="Line 328"
              y1="5.845"
              x2="5.845"
              transform="translate(162.986 31.884)"
              fill="none"
              stroke="#000"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2823"
              data-name="Path 2823"
              d="M399.237,278.506a6.152,6.152,0,0,1-8.7-8.7"
              transform="translate(-107.139 -96.105)"
              fill="none"
              stroke="#eb3a44"
              stroke-miterlimit="10"
              stroke-width="1.5"
            />
            <path
              id="Path_2824"
              data-name="Path 2824"
              d="M265.616,139.28c-2.608-8.046-5.248-16.478-3.842-24.819.965-5.721,3.787-10.972,7.1-15.739a71.7,71.7,0,0,1,19.172-18.973c8.739-5.78,18.709-9.363,28.5-13.091s19.657-7.734,27.906-14.194,14.808-15.771,15.694-26.211"
              transform="translate(-21.717 -20.5)"
              fill="none"
              stroke="#fec41d"
              stroke-linecap="square"
              stroke-miterlimit="10"
              stroke-width="1.5"
            />
            <path
              id="Path_2825"
              data-name="Path 2825"
              d="M208.95,149.789a201.712,201.712,0,0,1-16.1-27.366,23.445,23.445,0,0,1-2.562-7.363,8.589,8.589,0,0,1,2.2-7.227c2.821-2.686,7.93-2.022,10.314,1.057s1.982,7.824-.555,10.779A11.216,11.216,0,0,1,191.624,123c-5.613-1.151-9.829-5.861-15.214-7.817a16.622,16.622,0,0,0-13.513,1.053"
              transform="translate(9.044 -45.455)"
              fill="none"
              stroke="#6444f1"
              stroke-linecap="square"
              stroke-miterlimit="10"
              stroke-width="1.5"
            />
            <circle
              id="Ellipse_190"
              data-name="Ellipse 190"
              cx="4.414"
              cy="4.414"
              r="4.414"
              transform="translate(325.422 1.964)"
              fill="none"
              stroke="#000"
              stroke-linecap="round"
              stroke-linejoin="bevel"
              stroke-width="1.5"
            />
            <path
              id="Path_2826"
              data-name="Path 2826"
              d="M313.64,121.733l.567-6.449,6.305.554.559-6.363,6.5.571"
              transform="translate(-38.038 -46.494)"
              fill="none"
              stroke="#000"
              stroke-miterlimit="10"
              stroke-width="1.5"
            />
          </g>
        </svg>
        <span class="f-14 medium">{{ $fn.tr("lead_form_success_text") }}</span>
        <div
          class="vacancy_modal__success--button button flex a_center j_center f-white bold uppercase pointer"
          @click="back_to_vacancy()"
        >
          <svg
            id="Group_5_Copy_3"
            data-name="Group 5 Copy 3"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <path
              id="Combined_Shape_Copy_2"
              data-name="Combined Shape Copy 2"
              d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
              fill="#fff"
            />
          </svg>
          {{ $fn.tr("ok") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
import fix_100_vh_android from "@/mixins/fix_100_vh_android";
import fn from "@/helpers/func";
import axios from "axios";
export default {
  props: ["vacancy_data"],
  mixins: [resize_handler, fix_100_vh_android],

  data() {
    let validate_phone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ მხოლოდ ციფრები")));
        } else {
          callback();
        }
      }, 1000);
    };
    let validate_name = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("ველის შევსება სავალდებულოა")));
      } else {
        callback();
      }
    };

    return {
      recaptcha_verified: false,
      recaptcha_error: false,
      success_sent: false,
      file_list: [],
      file_obj: "",
      focuses: [],
      ruleForm: {
        name: "",
        phone: "",
        desc: "",
        type: ""
      },
      rules: {
        name: [{ validator: validate_name, trigger: "blur" }],

        phone: [{ validator: validate_phone, trigger: "blur" }]
      }
    };
  },
  mounted() {
    // console.log(this.vacancy_data);
    this.success_sent = false;
    axios
      .get(
        "http://api.ipify.org/?format=jsonp&callback=getIP?vue&type=script&lang=js&"
      )
      .then(res => console.log(res, "rrrrees"));
  },
  methods: {
    add_focus(name) {
      let _name = document.querySelector(".el-input__placeholder--name");

      let _phone = document.querySelector(".el-input__placeholder--phone");
      let _textarea = document.querySelector(
        ".el-input__placeholder--textarea"
      );
      if (!this.focuses.includes(name)) this.focuses.push(name);
      if (name == "name") {
        _name.classList.add("selected");
      } else if (name == "phone") {
        _phone.classList.add("selected");
      } else if (name == "textarea") {
        _textarea.classList.add("selected");
      }
    },
    remove_focus(name, field) {
      this.focuses = this.focuses.filter(foc => foc !== name);
      let _name = document.querySelector(".el-input__placeholder--name");

      let _phone = document.querySelector(".el-input__placeholder--phone");
      let _textarea = document.querySelector(
        ".el-input__placeholder--textarea"
      );
      if (field.length == 0) {
        if (name == "name") {
          _name.classList.remove("selected");
        } else if (name == "phone") {
          _phone.classList.remove("selected");
        } else if (name == "textarea") {
          _textarea.classList.remove("selected");
        }
      }
    },

    back_to_vacancy() {
      this.recaptcha_verified = false;
      this.recaptcha_error = false;
      this.success_sent = false;
      // setTimeout(() => {
      this.$refs["ruleForm"].resetFields();
      // }, 100);

      this.close_modal();
      // this.success_sent = false;

      // this.$store.state.main.lead_modal = !this.$store.state.main.lead_modal;
    },
    handle_exceed() {
      console.log("exceed");
    },
    handle_remove(file, _) {},

    on_success(data) {
      this.file_obj = data;
      console.log(this.file_obj);
    },

    recaptcha_success() {
      this.recaptcha_verified = true;
      this.recaptcha_error = false;
      console.log(this.recaptcha_verified);
    },
    recaptcha_fail() {
      this.recaptcha_verified = false;
      this.recaptcha_error = true;
      console.log(this.recaptcha_error);
    },

    close_modal() {
      document.querySelector(".modal")?.classList.remove("modal_active");
      this.$refs["ruleForm"].resetFields();

      setTimeout(() => {
        this.$store.state.main.lead_modal = !this.$store.state.main.lead_modal;
      }, 701);
    },

    async submit_form() {
      let params = {
        FirstName: this.ruleForm.name,
        PhoneNumber: String(this.ruleForm.phone),
        Comment:
          this.ruleForm.desc +
          JSON.stringify(this.$store.state.main.lead_modal_type.formValues)
            .slice(1, -1)
            .replaceAll(":", ",")
            .replaceAll(`"`, `'`),
        Product: this.$store.state.main.lead_modal_type.type,
        OperatorId: 104,
        Source: "tbcinsurance.ge",
        PageName: "12",
        Variant: "122",
        PageId: "1",
        PageUrl: "112",
        SourcePage: "jjk",
        Medium: "ee",
        Campaign: "22",
        Content: "233",
        Term: "11"
      };

      let res = await fn.postData(
        "main/serviceCaller?callerId=TbcInsuranceCalculators_getCalcSavecontact",
        params
      );

      if (res.data.status == 0) {
        this.success_sent = true;
      }

      console.log(res);
    },

    submitForm(formName) {
      console.log(
        this.ruleForm.desc +
          JSON.stringify(this.$store.state.main.lead_modal_type.formValues)
            .slice(1, -1)
            .replaceAll(":", ",")
            .replaceAll(`"`, `'`),
        "dd"
      );
      this.$refs[formName].validate(valid => {
        //&& this.recaptcha_verified
        if (valid ) {
          // alert('submit!');
          this.submit_form();
        } else {
          axios.get(
            "http://gd.geobytes.com/GetCityDetails?callback=?",
            function(data) {
              console.log(JSON.stringify(data, null, 2));
            }
          );
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  computed: {
    vacancy_modal() {
      return this.$store.state.main.lead_modal;
    }
  },
  watch: {
    vacancy_modal(ns, os) {
      if (ns == true) {
        setTimeout(() => {
          document
            .querySelector(".vacancy_modal")
            .classList.add("modal_active");
        }, 10);
      }
      if (this.windowWidth <= 767) {
        ns == true
          ? document.querySelector("body").classList.add("modal-open")
          : document.querySelector("body").classList.remove("modal-open");
        ns == true
          ? document.querySelector("html").classList.add("modal-open")
          : document.querySelector("html").classList.remove("modal-open");
      }
    },

    focuses(ns, os) {
      console.log(ns);
    },
    $route(to, from) {
      if (this.$store.state.main.lead_modal) {
        this.$store.state.main.lead_modal = !this.$store.state.main.lead_modal;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vacancy_modal {
  z-index: 999;
}
</style>
